/**
 * Solio PDP Community — horizontal-scroll carousel.
 *
 * Each row has a scrollable <ul> and two chevron buttons. The buttons
 * advance the scroll by ~one card width and hide themselves when their
 * edge is reached. Native swipe still works on touch devices; nav
 * buttons are hidden via CSS on coarse-pointer environments.
 */
(function () {
  'use strict';

  var rows = document.querySelectorAll('[data-solio-pdp-community] [data-community-rowwrap]');
  if (!rows.length) return;

  rows.forEach(function (wrap) {
    var row = wrap.querySelector('[data-community-row]');
    var prev = wrap.querySelector('[data-community-scroll="prev"]');
    var next = wrap.querySelector('[data-community-scroll="next"]');
    if (!row) return;

    function step() {
      var card = row.querySelector('li');
      var gap = parseFloat(getComputedStyle(row).columnGap) || 16;
      return card ? card.getBoundingClientRect().width + gap : 300;
    }

    function updateNav() {
      if (!prev || !next) return;
      var max = row.scrollWidth - row.clientWidth - 2;
      if (row.scrollLeft <= 2) {
        prev.setAttribute('hidden', '');
      } else {
        prev.removeAttribute('hidden');
      }
      if (row.scrollLeft >= max) {
        next.setAttribute('hidden', '');
      } else {
        next.removeAttribute('hidden');
      }
    }

    if (prev) {
      prev.addEventListener('click', function () {
        row.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        row.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    row.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();
  });
})();
